import BaseAPI from "./BaseAPI";

class SettingsAPI extends BaseAPI {
	
    settingsInit = async () => {
        var promise = null;
            promise = await this.init().get("/account/settings");
        return promise;
    };

    previewInvoice = async (data) => {
        var promise = null;
            promise = await this.init().post("/account/settings/preview/invoice", data);
        return promise;
    };

	storeSettings = async (data) => {
        data.company = data.company.toJsonString();
        var promise = null;
            promise = await this.init().post("/account/settings", data);
        return promise;
    };
    
        storeBaseSettings = async (data, type) => {
        
        var promise = null;
            promise = await this.init().post("/account/settings/"+type, data);
        return promise;
    }; 

        removeBaseSettings = async (data, type) => {
        
        var promise = null;
            promise = await this.init().delete("/account/settings/"+type+"/"+data.key);
        return promise;
    }; 

    dropboxAuthoriseWithCode= async (code) => {
        var promise = null;
        promise = await this.init().get("/account/settings/authorisedropbox/"+code);
        return promise;
    };
    
    setStorageBaseMap= async (data) => {
        var promise = null;
        promise = await this.init().post("/account/settings/storage/setBaseMap", data);
        return promise;
    };

    disconnectDropboxAccount= async (data) => {
        var promise = null;
        promise = await this.init().get("/account/settings/storage/disconnect");
        return promise;
    };
    
    storePDFTemplate = async (data, filedata) => {
        let formData = new FormData();
        formData.append("file", data);
        formData.append("filedata", JSON.stringify(filedata) );
        var promise = await this.init().post("/account/settings/upload/pdftemplate", formData,  {
                headers: {
                    "Content-Type": "multipart/form-data; charset=UTF-8",
            }});
        return promise;
    };

    recreatePDF = async (data) => {
        var promise = await this.init().post("/account/settings/upload/pdftemplate/recreate", data);
        return promise;
    };

    editWebsite = async (data) => {
        var promise = await this.init().post("/account/settings/editWebsite", data);
        return promise;
    }
    
}

export default new SettingsAPI();